import React, { useState } from 'react';

const Benefits = () => {
  const [activeCategory, setActiveCategory] = useState('pendidikan');

  const benefitCategories = {
    pendidikan: {
      title: "Manfaat Pendidikan",
      icon: "fas fa-graduation-cap",
      color: "from-blue-500 to-blue-600",
      benefits: [
        {
          title: "Akses ke E-book, Tafsir, dan Kitab Digital",
          description: "Santri dapat membuka materi pembelajaran seperti Al-Qur'an digital, tafsir, kitab hadits, dan modul pelajaran hanya lewat satu perangkat.",
          icon: "fas fa-book-open",
          impact: "Efisiensi belajar meningkat 70%"
        },
        {
          title: "Pembelajaran Interaktif melalui LMS",
          description: "Santri mengerjakan kuis, menyimak video, dan berdiskusi daring dengan guru melalui platform LMS resmi pondok.",
          icon: "fas fa-laptop",
          impact: "Engagement siswa naik 85%"
        },
        {
          title: "Catatan Belajar Terstruktur & Terintegrasi",
          description: "Santri menulis catatan digital, menambahkan gambar, audio, dan membuat mind map langsung dari iPad mereka.",
          icon: "fas fa-edit",
          impact: "Produktivitas belajar meningkat 60%"
        },
        {
          title: "Efisiensi Bawaan Alat Belajar",
          description: "Tidak perlu membawa banyak buku fisik; semua materi, tugas, dan jadwal pelajaran tersedia dalam iPad.",
          icon: "fas fa-weight-hanging",
          impact: "Beban tas berkurang 80%"
        },
        {
          title: "Kemandirian dalam Mengelola Tugas dan Waktu",
          description: "Kalender belajar, pengingat tugas, dan check-in harian tersedia di dalam sistem, membantu santri belajar mandiri.",
          icon: "fas fa-clock",
          impact: "Kedisiplinan meningkat 75%"
        },
        {
          title: "Persiapan Menuju Dunia Digital Modern",
          description: "iPad melatih santri terbiasa menggunakan teknologi edukatif seperti yang digunakan di perkuliahan dan dunia kerja.",
          icon: "fas fa-rocket",
          impact: "Kesiapan digital 90%"
        }
      ]
    },
    pengasuhan: {
      title: "Manfaat Pengasuhan",
      icon: "fas fa-home",
      color: "from-green-500 to-green-600",
      benefits: [
        {
          title: "Monitoring Real-time Aktivitas Harian",
          description: "Kehadiran sekolah, belajar malam, ibadah, makan, mandi, dan kebersihan terdata & langsung bisa dilihat wali santri via dashboard.",
          icon: "fas fa-eye",
          impact: "Transparansi 100%"
        },
        {
          title: "Laporan Sholat Wajib dan Sunnah",
          description: "Santri yang hadir/tidak hadir sholat Subuh, Zuhur, hingga Tahajjud dan Dhuha dicatat otomatis dan bisa dilihat wali.",
          icon: "fas fa-pray",
          impact: "Kedisiplinan ibadah naik 80%"
        },
        {
          title: "Laporan Keterlambatan Otomatis",
          description: "Sistem mencatat keterlambatan ke masjid, tidak hadir belajar malam, telat ke makan, dan lainnya secara otomatis & objektif.",
          icon: "fas fa-exclamation-triangle",
          impact: "Akurasi laporan 95%"
        },
        {
          title: "Penilaian Adab dan Kebersihan Digital",
          description: "Nilai sikap, kebersihan kamar, kerapihan, dan interaksi sosial santri dinilai musyrif dan langsung masuk sistem pengasuhan digital.",
          icon: "fas fa-star",
          impact: "Objektivitas penilaian 90%"
        },
        {
          title: "Monitoring Cepat oleh Musyrif",
          description: "Musyrif melihat data sholat, kehadiran, dan kondisi siswa dari iPad masing-masing untuk mengambil tindakan pembinaan yang tepat.",
          icon: "fas fa-tachometer-alt",
          impact: "Respon time 50% lebih cepat"
        },
        {
          title: "Sistem Perizinan 3 Arah Otomatis",
          description: "Wali Santri mengajukan izin dari rumah, manajemen & musyrif/guru menyetujui dari iPad, lalu hasil izin masuk ke iPad santri & notifikasi ke wali santri.",
          icon: "fas fa-exchange-alt",
          impact: "Efisiensi proses 85%"
        },
        {
          title: "Informasi Kesehatan Real-time",
          description: "Jika anak sakit, keluhan dan penanganannya dicatat perawat lalu masuk sistem → bisa langsung dilihat oleh orang tua melalui LMS.",
          icon: "fas fa-heartbeat",
          impact: "Komunikasi kesehatan 100%"
        }
      ]
    },
    teknologi: {
      title: "Manfaat Teknologi",
      icon: "fas fa-cog",
      color: "from-purple-500 to-purple-600",
      benefits: [
        {
          title: "Sistem MDM Terkontrol Penuh",
          description: "Pondok membatasi akses aplikasi, internet, dan waktu penggunaan. Tidak bisa dipakai untuk media sosial, hiburan, atau game.",
          icon: "fas fa-shield-alt",
          impact: "Kontrol keamanan 100%"
        },
        {
          title: "Integrasi Akademik dan Pengasuhan",
          description: "Guru dan musyrif sama-sama menggunakan iPad untuk mencatat nilai, ibadah, adab, dan laporan yang langsung bisa dilihat wali santri.",
          icon: "fas fa-link",
          impact: "Sinkronisasi data 95%"
        },
        {
          title: "Backup Data Otomatis",
          description: "Semua data pembelajaran dan pengasuhan tersimpan aman di cloud dengan backup otomatis setiap hari.",
          icon: "fas fa-cloud-upload-alt",
          impact: "Keamanan data 99.9%"
        },
        {
          title: "Update Sistem Terpusat",
          description: "Semua iPad mendapat update aplikasi dan konten secara otomatis dari server pusat tanpa mengganggu aktivitas belajar.",
          icon: "fas fa-sync-alt",
          impact: "Konsistensi sistem 100%"
        },
        {
          title: "Analytics dan Reporting",
          description: "Dashboard analytics memberikan insight mendalam tentang pola belajar, kehadiran, dan perkembangan setiap santri.",
          icon: "fas fa-chart-bar",
          impact: "Insight data 90%"
        },
        {
          title: "Skalabilitas Sistem",
          description: "Sistem dapat dengan mudah diperluas untuk menambah santri baru, fitur baru, atau unit pendidikan baru.",
          icon: "fas fa-expand-arrows-alt",
          impact: "Fleksibilitas 85%"
        }
      ]
    }
  };

  const overallImpacts = [
    {
      metric: "Efisiensi Pembelajaran",
      value: "75%",
      description: "Peningkatan efisiensi proses belajar mengajar",
      icon: "fas fa-chart-line",
      color: "text-blue-600"
    },
    {
      metric: "Transparansi Pengasuhan",
      value: "90%",
      description: "Tingkat transparansi aktivitas santri ke wali",
      icon: "fas fa-eye",
      color: "text-green-600"
    },
    {
      metric: "Kepuasan Wali Santri",
      value: "85%",
      description: "Tingkat kepuasan wali terhadap sistem monitoring",
      icon: "fas fa-smile",
      color: "text-purple-600"
    },
    {
      metric: "Kedisiplinan Santri",
      value: "80%",
      description: "Peningkatan kedisiplinan dalam ibadah dan belajar",
      icon: "fas fa-medal",
      color: "text-orange-600"
    }
  ];

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Manfaat Program Digitalisasi
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Dampak positif transformasi digital terhadap pembelajaran, pengasuhan, dan teknologi di Al Wafi
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center mb-12">
          {Object.entries(benefitCategories).map(([key, category]) => (
            <button
              key={key}
              onClick={() => setActiveCategory(key)}
              className={`mx-2 mb-4 px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center space-x-2 ${
                activeCategory === key
                  ? `bg-gradient-to-r ${category.color} text-white shadow-lg transform scale-105`
                  : 'bg-white text-gray-600 hover:bg-gray-50 shadow-md hover:shadow-lg'
              }`}
            >
              <i className={category.icon}></i>
              <span>{category.title}</span>
            </button>
          ))}
        </div>

        {/* Benefits Grid */}
        <div className="mb-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefitCategories[activeCategory].benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden">
                <div className={`h-2 bg-gradient-to-r ${benefitCategories[activeCategory].color}`}></div>
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <div className={`w-12 h-12 bg-gradient-to-r ${benefitCategories[activeCategory].color} rounded-lg flex items-center justify-center mr-4`}>
                      <i className={`${benefit.icon} text-white text-lg`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-800 leading-tight">{benefit.title}</h3>
                  </div>
                  <p className="text-gray-600 mb-4 leading-relaxed">{benefit.description}</p>
                  <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gradient-to-r ${benefitCategories[activeCategory].color} text-white`}>
                    <i className="fas fa-arrow-up mr-1"></i>
                    {benefit.impact}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Overall Impact Metrics */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Dampak Keseluruhan Program</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {overallImpacts.map((impact, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 p-6 text-center">
                <div className={`w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${impact.icon} ${impact.color} text-2xl`}></i>
                </div>
                <div className={`text-4xl font-bold ${impact.color} mb-2`}>{impact.value}</div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{impact.metric}</h3>
                <p className="text-sm text-gray-600">{impact.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Comparison: Before vs After */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Perbandingan: Sebelum vs Sesudah</h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Before */}
            <div className="bg-red-50 rounded-xl p-6 border-l-4 border-red-500">
              <h3 className="text-2xl font-bold text-red-700 mb-6 flex items-center">
                <i className="fas fa-times-circle mr-3"></i>
                Sebelum Digitalisasi
              </h3>
              <div className="space-y-4">
                {[
                  "Komunikasi dengan wali santri terbatas",
                  "Monitoring aktivitas santri manual",
                  "Laporan perkembangan tidak real-time",
                  "Pembelajaran masih konvensional",
                  "Data tersebar di berbagai sistem",
                  "Proses administrasi memakan waktu lama"
                ].map((item, index) => (
                  <div key={index} className="flex items-center text-red-700">
                    <i className="fas fa-minus-circle mr-3 text-red-500"></i>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* After */}
            <div className="bg-green-50 rounded-xl p-6 border-l-4 border-green-500">
              <h3 className="text-2xl font-bold text-green-700 mb-6 flex items-center">
                <i className="fas fa-check-circle mr-3"></i>
                Sesudah Digitalisasi
              </h3>
              <div className="space-y-4">
                {[
                  "Komunikasi real-time dengan wali santri",
                  "Monitoring otomatis 24/7",
                  "Laporan perkembangan instant",
                  "Pembelajaran interaktif dan modern",
                  "Data terintegrasi dalam satu sistem",
                  "Proses administrasi otomatis dan cepat"
                ].map((item, index) => (
                  <div key={index} className="flex items-center text-green-700">
                    <i className="fas fa-check-circle mr-3 text-green-500"></i>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Preview */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Testimoni Stakeholder</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-user-tie text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Kepala Sekolah</h3>
              <p className="text-gray-600 italic">
                "Program digitalisasi ini membawa Al Wafi ke era baru pendidikan Islam yang modern namun tetap berpegang pada nilai-nilai tradisional."
              </p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-chalkboard-teacher text-green-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Guru</h3>
              <p className="text-gray-600 italic">
                "iPad dan LMS memudahkan saya dalam menyampaikan materi dan memantau perkembangan setiap santri secara individual."
              </p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-users text-purple-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Wali Santri</h3>
              <p className="text-gray-600 italic">
                "Sekarang saya bisa memantau aktivitas anak saya di pondok secara real-time. Sangat membantu dan menenangkan."
              </p>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
            <h2 className="text-3xl font-bold mb-4">Bergabunglah dalam Transformasi Digital</h2>
            <p className="text-xl text-blue-100 mb-6 max-w-3xl mx-auto">
              Rasakan sendiri manfaat luar biasa dari program digitalisasi Al Wafi untuk masa depan pendidikan yang lebih baik
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-blue-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-info-circle mr-2"></i>
                Pelajari Lebih Lanjut
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-phone mr-2"></i>
                Hubungi Kami
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Benefits;
